// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3Q1YQ","content":"styles_content__3GUsf","checkbox":"styles_checkbox__qj5Ua","checkboxLabel":"styles_checkboxLabel__1Dbby"};